<template>
  <div>
    <v-navigation-drawer
      persistent
      :clipped="true"
      v-model="leftDrawer"
      enable-resize-watcher
      fixed
      app
      stateless
      hide-overlay
      width="300"
      :mini-variant.sync="mini"
    >
      <v-list dense two-line>
        <template v-for="(item, idx) in menus">
          <div v-if="item.heading" class="subheader grey--text">
            {{ item.heading }}
          </div>
          <v-list-group
            v-else-if="item.children"
            v-model="item.model"
            :key="item.dbid"
            :prepend-icon="item.icon"
            no-action
          >
            <v-list-tile
              slot="activator"
            >
              <v-list-tile-content>
                <span>
                  {{ item.name }}
                </span>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-for="(child, i) in item.children"
              :key="i"
              :to="child.route"
              ripple
              :class="{'x-active-menu-item': $route.path.startsWith(child.route)}"
            >
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <span >{{child.name}}</span>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile
            v-else
            :to="item.route"
            :disabled="mini"
            :key="item.dbid"
            ripple
            :class="{'x-active-menu-item': $route.path.startsWith(item.route)}"
          >
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <span>
                {{ item.name }}
              </span>
            </v-list-tile-content>
            <v-list-tile-action v-if="idx === 0">
              <v-btn icon ripple @click.stop.prevent="mini = !mini">
                <v-icon>menu</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider v-if="idx === 0"></v-divider>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      app
      :clipped-left="true"
      dark
      flat
      dense
      class="main-nav-bar"
      style="color: rgba(255,255,255,.85); background-color: rgb(0, 94, 166);"
    >

      <v-toolbar-side-icon/>

      <!--<a id="logo" href="/" class="router-link-active">-->
      <!--<img src="/static/logo.png">-->
      <!--</a>-->

      <v-toolbar-title>
        {{ title }}
      </v-toolbar-title>
      <v-spacer/>

      <v-toolbar-items>

        <v-btn
          flat
          dark
          to="/user"
        >
          <v-icon>account_circle</v-icon>
          {{ name }} [{{ username }}]
        </v-btn>

        <v-menu
          :nudge-bottom="48"
          bottom
          light
        >
          <v-btn slot="activator" flat dark>
            <v-icon>supervisor_account</v-icon>
            <span>{{ deptName }} / {{ roleName }}</span>
            <v-icon dark>arrow_drop_down</v-icon>
          </v-btn>

          <v-list>
            <v-list-tile
              v-for="udr in deptRoles"
              :key="udr.dbid"
              ripple
              :to="udr.roleRoute"
              @click.native="$store.commit('changeRole', udr)"
            >
              <v-list-tile-content>
                <v-list-tile-title>{{ udr.deptName }} / {{ udr.roleName }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>

        <v-btn
          flat
          dark
          to="/login"
        >
          <v-icon>exit_to_app</v-icon>
          退出
        </v-btn>

      </v-toolbar-items>
    </v-toolbar>
    <v-content align-center>
      <router-view/>
    </v-content>
  </div>
</template>
<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'

const menuUri = '/api/index/menu';
const funcAndParamUri = '/api/index/funcs/and/params';

function flatten(tree, attr) {
  if (tree) {
    if (Array.isArray(tree)) {
      const subRoutes = tree.map(n => flatten(n, attr));
      return subRoutes.reduce((a1, a2) => [...a1, ...a2])
    } else {
      const subRoutes = flatten(tree.children, attr);
      const route = tree[attr];
      return route ? [route, ...subRoutes] : subRoutes;
    }
  } else {
    return [];
  }
}

export default {
  name: "Main",
  data() {
    return {
      leftDrawer: false,
      fixed: false,
      mini: false,
      title: '云南省工业和信息化项目管理系统',
      menus: []
    }
  },
  created() {
    this.leftDrawer = true;
  },
  computed: {
    ...mapGetters([
      'authenticated',
      'name',
      'username',
      'password',
      'deptId',
      'roleId',
      'deptName',
      'roleName',
      'deptRoles'
    ])
  },


  beforeRouteEnter(to, from, next) {
    // 在渲染该组件的对应路由被 confirm 前调用
    // 不！能！获取组件实例 `this`
    // 因为当守卫执行前，组件实例还没被创建
    //console.log("in Main beforeRouteEnter");

    Vue.axios.all([
      Vue.axios.get(menuUri),
      Vue.axios.get(funcAndParamUri)
    ]).then(
      Vue.axios.spread(
        (rspMenu, rspFunc) => next(
          vm => {
            vm.menus = rspMenu.data;
            vm.$store.commit("funcsAndParams", rspFunc.data);
            const menus = flatten(rspMenu.data, 'route');
            // console.log(menus);
            vm.$store.commit("menus", menus);
          })
      )
    )
  },

  beforeRouteUpdate(to, from, next) {
    // 在当前路由改变，但是该组件被复用时调用
    // 举例来说，对于一个带有动态参数的路径 /foo/:id，在 /foo/1 和 /foo/2 之间跳转的时候，
    // 由于会渲染同样的 Foo 组件，因此组件实例会被复用。而这个钩子就会在这个情况下被调用。
    // 可以访问组件实例 `this`
    //console.log("in Main beforeRouteUpdate");
    // console.log(from.path);
    if (this.menus.length === 0 || from.path === "/login") {
      Vue.axios.all([
        Vue.axios.get(menuUri),
        Vue.axios.get(funcAndParamUri)
      ]).then(
        Vue.axios.spread(
          (rspMenu, rspFunc) => {
            this.menus = rspMenu.data;
            //console.log(rspFunc.data);
            this.$store.commit("funcsAndParams", rspFunc.data);

            const menus = flatten(rspMenu.data, 'route');
            // console.log(menus);
            this.$store.commit("menus", menus);

            next();
          })
      )
    } else {
      next();
    }
  },

  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    //console.log("in Main beforeRouteLeave");
    const answer = window.confirm('确定要退出系统吗？');
    if (answer) {
      this.menus = [];

      this.$store.commit("menus", []);

      // 退出系统，清空当前用户信息。
      this.$store.commit('logout');
      next()
    } else {
      next(false)
    }
  },

  watch: {
    roleId(nv, ov) {
      //console.log("in watch roleId");

      Vue.axios.all([
        Vue.axios.get(menuUri),
        Vue.axios.get(funcAndParamUri)
      ]).then(
        Vue.axios.spread(
          (rspMenu, rspFunc) => {
            this.menus = rspMenu.data;
            //console.log(rspFunc.data);
            this.$store.commit("funcsAndParams", rspFunc.data);
          })
      )
    }
  },

  methods: {}

}
</script>

<style>
#logo > img {
  height: 40px;
  vertical-align: middle;
}

main div.content--wrap {
  padding: 1rem;
}

.main-nav-bar {
  border-bottom-color: rgba(0, 0, 0, 0.12);
  border-bottom-width: 2px;
  border-bottom-style: solid;
}

.x-active-menu-item {
  border-right: 3px solid red;
  background-color: whitesmoke;
}

.x-active-menu-item .v-icon {
  color: #1976d2 !important
}


</style>



// WEBPACK FOOTER //
// src/components/Main.vue